import script from "./TranscriptDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TranscriptDialog.vue?vue&type=script&setup=true&lang=js"

import "./TranscriptDialog.vue?vue&type=style&index=0&id=5882ab54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5882ab54"]])

export default __exports__